module.exports = __webpack_public_path__ + "static/3-f60dc7ca7cacbde10bdad0cf7d7a71b2.jpg";